import React from 'react';
import { Link } from 'react-router';
import { connect } from 'react-redux';
import css from '../styles/home-area.css';

const { Component } = React;

class Area extends Component {
  render() {
    return (
      <div className="home-area clearfix" data-aos="fade-zoom-in">
        <div className="home-area__wrapper">
          <img className="home-area__img bubble" src={this.props.area.thumbnailSrc} />
          <h3 className="home-area__title">{this.props.area.label}</h3>
          <p className="home-area__content">{this.props.area.summary}</p>
        </div>
        <Link className="home-area__link bfm-link" to="/areas">More</Link>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {};
}

function mapDispatchToProps(dispatch) {
  return {};
}

let AreaContainer = connect(mapStateToProps, mapDispatchToProps)(Area);

export { Area, AreaContainer };



// WEBPACK FOOTER //
// ./app/screens/App/screens/Home/components/home-area.js